import {remCalc} from '../../_utils'

// Stories

export default {
    baseStyle: ({
        autoplayDelay,
        maskgroup,
    }: {
        autoplayDelay: number
        maskgroup: {maskheaderactive?: boolean; opacity: string}
    }) => {
        // ignore opacity color, it's always black
        const maskGradient = maskgroup?.maskheaderactive ? 'rgba(0, 0, 0, 0.5)' : 'none'

        return {
            container: {
                maxW: remCalc(1920),
                position: 'relative',
                my: {base: remCalc(16), md: remCalc(40)},
                mx: 'auto',
                bgColor: 'background.default',
            },
            slidercontainer: {
                w: '100%',
                maxW: {
                    base: remCalc(343),
                    sm: remCalc(720),
                    md: remCalc(976),
                    lg: remCalc(1400),
                },
                margin: '0 auto',
                bgColor: 'background.default',

                // Swiper component styling
                '.stories-pagination-bullet': {
                    borderRadius: 0,
                    h: remCalc(2),
                    background: 'hsla(0, 0%, 100%, .5)',
                    opacity: 1,
                    flexGrow: 1,
                    cursor: 'pointer',
                },
                '.stories-pagination-bullet span': {
                    display: 'block',
                    h: remCalc(2),
                    w: 0,
                    background: 'white',
                },
                '.stories-pagination-bullet.full span': {
                    w: '100%',
                },
                '.stories-pagination-bullet.current span': {
                    transition: `width ${autoplayDelay}s linear`,
                    w: '100%',
                },
                '.swiper-slide .current .slideimage': {
                    transition: `transform ${autoplayDelay}s linear`,
                    transform: 'scale(1.1)',
                },
            },
            mediaContainer: {
                position: 'relative',
                w: '100%',
                h: '100%',
            },
            screenImg: {
                w: '100%',
                h: '100%',
                objectFit: 'cover',
            },
            screenText: {
                position: 'absolute',
                top: 0,
                bottom: 0,
                left: '50%',
                transform: 'translateX(-50%)',
                justifyContent: 'center',
                alignItems: 'center',
                w: '100%',
                background: maskGradient,
            },
            heading: {
                mb: {base: remCalc(16), md: remCalc(24), lg: remCalc(40)},
                w: '80%',
            },
            closeButton: {
                zIndex: 3,
                color: 'text.inverse',
                position: 'absolute',
                top: {base: remCalc(12), sm: remCalc(14), md: remCalc(12)},
                right: {base: remCalc(12), sm: remCalc(14), md: remCalc(12)},
            },
            chevronIcon: {
                w: remCalc(40),
                h: remCalc(40),
                position: 'absolute',
                top: '50%',
                transform: 'translateY(-50%)',
                borderRadius: '50%',
                cursor: 'pointer',
                zIndex: 10,
                background: 'transparent',
                color: 'text.inverse',
            },
            slide: {
                color: 'text.inverse',
                w: '100%',
                maxW: '100%',
                h: '100%',
                maxH: '100%',
                overflow: 'hidden',
            },
            slidemedia: {
                w: '100%',
                h: '100%',
                objectFit: 'cover',
                zIndex: 1,
            },
            slidetextblock: {
                position: 'absolute',
                top: 0,
                left: '50%',
                transform: 'translateX(-50%)',
                w: '80%',
                h: {base: `calc(100% - ${remCalc(34)})`, sm: `calc(100% - ${remCalc(50)})`},
                alignItems: 'flex-start',
                justifyContent: 'flex-end',
                zIndex: 3,
                gap: {base: remCalc(16), sm: remCalc(24)},
            },
            slidetitle: {
                w: '100%',
                textAlign: 'left',
            },
            slidebodycopy: {
                w: '100%',
                textAlign: 'left',
            },
            slidemask: {
                position: 'absolute',
                w: '100%',
                h: '100%',
                background: maskGradient,
                zIndex: 2,
            },
            pagination: {
                zIndex: 10,
                position: 'absolute',
                bottom: {base: `${remCalc(16)} !important`, md: `${remCalc(24)} !important`},
                left: '50% !important',
                transform: 'translateX(-50%)',
                w: '80% !important',
                justifyContent: 'space-between',
                gap: remCalc(4),
            },
        }
    },
}
